import i18n from '~/i18n';

export let i18nMap = (keyName, key) => it => filterMap(i18n.t(`cts.${keyName}.${it}`), it, key);

export let filterMap = (label, value, key) =>
    value ? { label, value, key: key } : { label, value: label, key: key };

export default () => [
    {
        ...i18nMap('filterNames')('employment_types'),
        options: ['INTERN', 'FULL_TIME', 'TEMPORARY']
            .map(i18nMap('employmentTypes', 'employment_types'))
            .concat(
                i18nMap('employmentTypes', 'custom_employment_types')('CREDIT_GIVING_INTERNSHIP')
            ),
    },
    {
        ...i18nMap('filterNames')('education_level'),
        options: [
            'BACHELORS_OR_EQUIVALENT',
            'MASTERS_OR_EQUIVALENT',
            'DOCTORAL_OR_EQUIVALENT',
            'MBA_OR_EQUIVALENT',
            'DBA_OR_EQUIVALENT',
        ].map(i18nMap('educationLevels', 'education_level')),
    },
    {
        ...i18nMap('filterNames')('job_category'),
        options: [
            'ACCOUNTING_AND_FINANCE',
            'ADMINISTRATIVE_AND_OFFICE',
            'ADVERTISING_AND_MARKETING',
            'ART_FASHION_AND_DESIGN',
            'BUSINESS_OPERATIONS',
            'COMPUTER_AND_IT',
            'CUSTOMER_SERVICE',
            'EDUCATION',
            'HEALTHCARE',
            'HUMAN_RESOURCES',
            'INSTALLATION_MAINTENANCE_AND_REPAIR',
            'LEGAL',
            'MANAGEMENT',
            'MANUFACTURING_AND_WAREHOUSE',
            'MEDIA_COMMUNICATIONS_AND_WRITING',
            'PROTECTIVE_SERVICES',
            'REAL_ESTATE',
            'SALES_AND_RETAIL',
            'SCIENCE_AND_ENGINEERING',
            'SOCIAL_SERVICES_AND_NON_PROFIT',
            'TRANSPORTATION_AND_LOGISTICS',
        ].map(i18nMap('educationFields', 'job_category')),
    },
    {
        ...i18nMap('filterNames')('address'),
        options: [
            'Afghanistan',
            'Albania',
            'Algeria',
            'Angola',
            'Argentina',
            'Armenia',
            'Australia',
            'Austria',
            'Azerbaijan',
            'Bahamas',
            'Bahrain',
            'Bangladesh',
            'Belarus',
            'Belgium',
            'Benin',
            'Botswana',
            'Brazil',
            'Bulgaria',
            'Burkina Faso',
            'Burundi',
            'Cabo Verde',
            'Cambod',
            'Canada',
            'Croatia',
            'China',
            'Colombia',
            'Congo',
            'Costa Rica',
            'Ivory Coast',
            'Croatia',
            'Cyprus',
            'Czechia',
            'Denmark',
            'Ecuador',
            'Egypt',
            'El Salvador',
            'Estonia',
            'Ethiopia',
            'Fiji',
            'Finland',
            'France',
            'Gabon',
            'Gambia',
            'Germany',
            'Ghana',
            'Greece',
            'Guatemala',
            'Guinea',
            'Hungary',
            'Hong Kong',
            'Iceland',
            'India',
            'Indonesia',
            'Iraq',
            'Ireland',
            'Israel',
            'Italy',
            'Japan',
            'Jordan',
            'Kazakhstan',
            'Kenya',
            'Korea, South',
            'Kuwait',
            'Laos',
            'Latvia',
            'Lebanon',
            'Liechtenstein',
            'Lithuania',
            'Luxembourg',
            'Macao',
            'Malaysia',
            'Mali',
            'Malta',
            'Martinique',
            'Mauritania',
            'Mayotte',
            'Mexico',
            'Micronesia (Federated States of)',
            'Monaco',
            'Mongolia',
            'Morocco',
            'Mozambique',
            'Myanmar',
            'Namibia',
            'Nepal',
            'Netherlands',
            'New Zealand',
            'Niger',
            'Nigeria',
            'North Macedonia',
            'Norway',
            'Oman',
            'Pakistan',
            'Panama',
            'Paraguay',
            'Peru',
            'Philippines',
            'Poland',
            'Portugal',
            'Puerto Rico',
            'Qatar',
            'Romania',
            'Russia',
            'Rwanda',
            'Saudi Arabia',
            'Senegal',
            'Serbia',
            'Singapore',
            'Slovakia',
            'Slovenia',
            'South Africa',
            'South Korea',
            'Spain',
            'Sri Lanka',
            'Sudan',
            'Sweden',
            'Switzerland',
            'Taiwan',
            'Thailand',
            'Timor-Leste',
            'Trinidad and Tobago',
            'Tunisia',
            'Turkey',
            'USA',
            'Ukraine',
            'United Arab Emirates',
            'United Kingdom',
            'Uzbekistan',
            'Venezuela',
            'Vietnam',
            'Yemen',
            'Zambia',
            'Zimbabwe',
        ].map(i18nMap('countries', 'address')),
        settings: {
            limit: 5,
        },
    },
    {
        ...i18nMap('filterNames')('sector'),
        options: [
            'Consulting',
            'Consumer Goods',
            'Engineering',
            'Financial Services / Banking',
            'Goverment / Public Administration / Non Profit',
            'International Trade & Development',
            'Manufacturing',
            'Media / Entertainment',
            'Petroleum / Energy',
            'Pharma / Healthcare / Biotech',
            'Real Estate / Construction / Infrastructure',
            'Technology (IT) / Telecom',
            'Transportations & Logistics',
            'Other',
        ].map(i18nMap('sectors', 'sector')),
    },
    {
        ...i18nMap('filterNames')('languages'),
        options: [
            'Aceh',
            'Afrikaans',
            'Albanian',
            'Amharic',
            'Arabic',
            'Arakanese',
            'Armenian',
            'Azeri',
            'Badini',
            'Basque',
            'Belarusian',
            'Bengali',
            'Berber',
            'Bosnian',
            'Bulgarian',
            'Burmese',
            'Cantonese',
            'Catalan',
            'Cebuano',
            'Chechen',
            'Chin',
            'Chinese',
            'Croatian',
            'Czech',
            'Danish',
            'Dari',
            'Dutch',
            'English',
            'Estonian',
            'Faroese',
            'Filipino',
            'Finnish',
            'French',
            'German',
            'Greek',
            'Greenlandic',
            'Hausa',
            'Hebrew',
            'Hindi',
            'Hungarian',
            'Icelandic',
            'Indonesian',
            'Italian',
            'Japanese',
            'Kazakh',
            'Kinyarwanda',
            'Kirundi',
            'Korean',
            'Kurdish',
            'Kurmanji',
            'Kven',
            'Latin',
            'Latvian',
            'Lingala',
            'Lithuanian',
            'Macedonian',
            'Malagasy',
            'Malaysian',
            'Mandarin',
            'Mongolian',
            'Nepali',
            'Norwegian',
            'Oromo',
            'Other',
            'Panjabi',
            'Pashto',
            'Persian',
            'Polish',
            'Portuguese',
            'Punjabi',
            'Romanes',
            'Romani',
            'Romanian',
            'Russian',
            'Sami',
            'Serbian',
            'Sign_language',
            'Slovak',
            'Slovene',
            'Somali',
            'Sorani',
            'Spanish',
            'Swahili',
            'Swedish',
            'Tagalog',
            'Tamil',
            'Thai',
            'Tigrinya',
            'Turkish',
            'Ukrainian',
            'Urdu',
            'Uyghur',
            'Vietnamese',
            'Wolof',
        ].map(i18nMap('languages', 'languages')),
    },
];
